<template>
  <vue-custom-scrollbar class="scroll_wrap">
    <v-row
      class="ma-0 px-6 px-md-15 py-5 bg-gray"
      align="center"
      justify="space-between"
    >
      <v-col cols="auto" class="pa-0">
        <v-row class="ma-0" align="center">
          <v-col cols="auto" class="pa-0 mr-5">
            <v-img src="~@/img/main_img_team.png"></v-img>
          </v-col>
          <v-col cols="auto" class="pa-0">
            <span class="tab-title mr-4">Q&A</span>
            <span class="count">{{ qnaList.length }}</span>
            <span class="unit">&nbsp;{{ $t('건') }}</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="auto" class="pa-0 ml-auto">
        <PopQnaAdd @save="getQnaList"></PopQnaAdd>
      </v-col>
    </v-row>
    <v-row class="mx-0 mx-md-15 mt-4 mt-md-8 mb-0">
      <v-col class="pa-0">
        <v-row
          class="ma-0 px-6 py-4 bg-gray"
          align="center"
          justify="space-between"
        >
          <v-col cols="auto" class="pa-0 head-title">{{
            $t('나의 Q&A')
          }}</v-col>
          <v-col cols="auto" class="pa-0">
            {{ $t('질문 답변') }}
            <a class="submit-count">{{ qnaList.length }}</a
            >{{ $t('건') }}
          </v-col>
        </v-row>
        <v-row
          v-for="(item, idx) in qnaList"
          class="ma-0 px-6 py-5 bd-B-1px"
          align="center"
          justify="space-between"
          :key="'qna' + idx"
        >
          <PopQnaDetail :cqa="item"
            >{{ $t('작성일') }} {{ item.cqaDate }}</PopQnaDetail
          >

          <v-col cols="auto" class="pa-0 ml-10 date-created">
            <template v-if="item.cqaReplyYn === 'N'">{{
              $t('답변대기')
            }}</template>
            <template v-else>{{ $t('답변완료') }}</template>
          </v-col>
          <v-col cols="auto" class="pa-0">
            <i-btn class="ml-8 btn-type-03" @click="delQnaConfirm(item)">{{
              $t('삭제')
            }}</i-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </vue-custom-scrollbar>
</template>

<script>
import PopQnaAdd from '@/components/PopQnaAdd.vue';
import PopQnaDetail from '@/components/PopQnaDetail.vue';
import { getAuthJson, postAuthJson } from '@/api/network';
export default {
  components: { PopQnaAdd, PopQnaDetail },
  data() {
    return {
      qnaList: [],
    };
  },
  mounted() {
    this.getQnaList();
  },
  methods: {
    getQnaList: function() {
      getAuthJson(
        'api/v1/' + this.$route.params.tenantKey + '/qna/list',
        {},
      ).then(res => {
        if (res.status == 200) {
          this.qnaList = res.data.qnas;
        }
      });
    },
    delQnaConfirm: function(qna) {
      var v = {
        title: '알림',
        message: 'QnA를 삭제하시겠습니까?',
        useCancel: true,
        callback: () => this.delQna(qna),
      };
      this.$showAlert(v);
    },
    delQna: function(qna) {
      const p = { cqaId: qna.cqaId };
      postAuthJson('api/v1/' + this.$route.params.tenantKey + '/delete/qna', p)
        .then(res => {
          if (res.status == 200 && res.data?.message) {
            this.$showAlert({
              message: res.data.message,
              callback: this.getQnaList,
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
  },
};
</script>

<style></style>
